import { gql } from "@apollo/client";

export const DELETE_SKYNET_USER = gql`
  mutation deleteSkynetUser($input: DeleteSkynetUserInput!) {
    rolesAndPermissions {
      deleteSkynetUser(input: $input) {
        success
      }
    }
  }
`;
